import { FC } from 'react';
import { Center } from '@chakra-ui/react';

import ErrorCard from 'components/ErrorCard';
import Loader from 'components/Loader';
import * as OfferDetailsLayout from 'layouts/OfferDetailsLayout';
import * as OffersLayout from 'layouts/OffersLayout';

import CollectionCard, {
  CollectionCardLink,
} from '../../components/CollectionCard';
import useGetToolboxCollections from '../../hooks/useGetToolboxCollections';
import useGetToolboxCollectionsCount from '../../hooks/useGetToolboxCollectionsCount';
import * as routes from '../../routes';
import locales from './locales';

const Collections: FC = () => {
  const {
    error,
    items: collections,
    loading,
    refetch,
  } = useGetToolboxCollections();

  const { count } = useGetToolboxCollectionsCount();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Center h="100%">
        <ErrorCard retry={refetch} />
      </Center>
    );
  }

  return (
    <OffersLayout.PageContainer
      trackViewProps={{
        pageName: 'ToolboxCollections Viewed',
        usePrefix: false,
      }}
    >
      <OfferDetailsLayout.BackButton to={routes.root} />

      <OffersLayout.PageTitle
        count={count}
        description={locales.description}
        title={locales.title}
      />

      {collections ? (
        <OffersLayout.ListGrid>
          {collections.map((collection) => (
            <CollectionCardLink
              key={collection.toolboxCollectionId}
              to={{
                pathname: routes.getCollectionPath(
                  collection.toolboxCollectionId,
                ),
                state: { from: 'all-collections' },
              }}
            >
              <CollectionCard collection={collection} />
            </CollectionCardLink>
          ))}
        </OffersLayout.ListGrid>
      ) : null}
    </OffersLayout.PageContainer>
  );
};

export default Collections;
